module.exports = __webpack_public_path__ + "img/ic_mass_clear_history.svg";